import styled from 'styled-components';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import Image from '../../Image';

export const desktopImageTopOffset = spacing(4);
export const desktopImageLeftOffset = spacing(12.25);

export const desktopImageHeight = spacing(66);
export const desktopImageWidth = spacing(68.25);
export const tabletImageHeight = spacing(50);
export const mobileImageHeight = spacing(36);

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  z-index: 1; // to ensure image is on top of the quote container

  height: ${mobileImageHeight};
  width: 100%;

  ${mediaQuery.tabletPortrait`
    height: ${tabletImageHeight};
  `}

  ${mediaQuery.desktop`
    height: ${desktopImageHeight};
    width: ${desktopImageWidth};
    top: ${desktopImageTopOffset};
    left: 0;
  `}
`;

export const StyledImage = styled(Image)`
  height: 100%;
  width: 100%;
  object-position: 50% 50%;
  object-fit: cover;
  border-radius: 0;

  @media screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: none;
  }
`;
